// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import SearchResultsOther from './SearchResultsOther'

class SearchResults extends React.Component {
	render() {
		if ( this.props.error ) {
			return null
		}

		const { translate, isLoading, hasSearched, searchTerm, searchResults } = this.props
		let resultsWrapClass = isLoading ? 'search-results-wrapper -is-loading' : 'search-results-wrapper'

		if ( searchResults.results_number && searchResults.results_number > 9 ) {
			resultsWrapClass += ' -many-results'
		}

		return (
			<div className={ resultsWrapClass }>
				<div className="search-results">
					<div className="-results">
						<LoadingSpinner />

						<div className="-heading">
							<h2>{ translate( 'Search results' ) }</h2>
						</div>

						{ hasSearched && searchResults && searchResults.has_results == false &&
							<div className="-no-results">
								<p>{ translate( 'Nothing found.' ) }</p>
							</div>
						}

						{ searchResults.has_results &&
							<SearchResultsOther />
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.search.isLoading,
		hasSearched: state.search.hasSearched,
		error: state.search.error,
		searchTerm: state.search.searchTerm,
		searchResults: state.search.searchResults
	}
}

export default localize(
	connect( mapStateToProps )( SearchResults )
)
